import { People } from './people';

export const PEOPLE : People[] = [
   {
      id:'0',
      name_ru:'Жуков И.А.',
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Zhukov.jpg',
      description: ``,
      email: `scyth7@bk.ru`,
      country: `ru`
   },
   {
      id:'1',
      name_ru:'Архипенко А.А.',
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Arhipenko.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'2',
      name_ru:`Беспалов Р.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Bespalov.jpg',
      description: ``,
      email: `gostunsky@gmail.com`,
      country: `ru`
   },
   {
      id:'3',
      name_ru:`Добромыслов Л.Б.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Dobromyslov.jpg',
      description: ``,
      email: `adobromislova@mail.ru`,
      country: `ru`
   },
   {
      id:'4',
      name_ru:`Ермолов Ф.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Ermolov.jpg',
      description: ``,
      email: `qutlug_bulsun@mail.ru`,
      country: `ru`
   },
   {
      id:'5',
      name_ru: `Зайцев В.В.`,
      name_en: `Vasiliy Zaytsev`,
      roles:[
         0,
         1
      ],
      image:'/assets/images/Zaytsev.jpg',
      description: `Старший научный сотрудник Отдела нумизматики Государственного исторического музея (Москва, Россия)`,
      email: `numizmat_gim@mail.ru`,
      country: `ru`
   },
   {
      id:'6',
      name_ru: `Титов Г.А.`,
      name_en: `Georgiy Titov`,
      roles:[
         0,
         1
      ],
      image:'/assets/images/Titov.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'7',
      name_ru: `Гоглов С.А.`,
      name_en: `Sergey A. Goglov`,
      roles:[
         0
      ],
      image:'/assets/images/Goglov.jpg',
      description: ``,
      email: `goglov@mail.ru`,
      country: `ru`
   },
   {
      id:'8',
      name_ru:`Големихов А.В.`,
      name_en: `Alexey V. Golemikhov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'9',
      name_ru: `Петров А.Н.`,
      name_en: `Alexander Petrov`,
      roles:[
         0
      ],
      image:'/assets/images/Petrov.jpg',
      description: `Научная степень – кандидат исторических наук, МГУ им. Ломоносова 1995 г. Настольная золотая медаль «Окончившему университет с отличием», МГУ 1992 г. Специалист в области источниковедения, экономической и церковной дипломатии (Web of Science ResearcherID O-6915-2015). Награждён Патриархом Московским и Всея Руси Алексием II 10.04.2006 г. медалью Русской Православной Церкви преподобного Серафима Саровского II ст. №168 во внимание к трудам по изданию спецвыпуска журнала «Фома» о Православии в Норвегии. Также награждён архиерейской грамотой председателя Отдела внешних церковных связей Русской Православной Церкви Митрополита Смоленского и Калининградского Кирилла 25.04.2005 г.`,
      email: `petrov@infoera.no`,
      country: `ru`
   },
   {
      id:'10',
      name_ru:`Сорокин И.Ю.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `sorokiniu@icloud.com`,
      country: `ru`
   },
   {
      id:'11',
      name_ru:`Тигунцев Ю.Г.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Tiguntsev.jpg',
      description: `Краевед из Брянской области РФ. Родился 10.05.1963 г. Во время учёбы в институте проявил интерес к нумизматике Императорского периода России, вёл переписку с хранителем, а затем главным научным сотрудником ГИМ В.В. Уздениковым. С 2011 года публикует работы по нумизматике и сфрагистике русского Средневековья. В настоящее время в круг интересов исследователя входит сфрагистика и нумизматика Черниговской земли периода формирования и укрепления Киевской Руси (IX - XIII вв).`,
      email: `tigun2@yandex.ru`,
      country: `ru`
   },
   {
      id:'12',
      name_ru:`Гулецкий Д.В.`,
      name_en:`Dzmitry Huletski`,
      roles:[
         0,
         1
      ],
      image:'/assets/images/Huletski.jpg',
      description: ``,
      email: ``,
      country: `by`
   },
   {
      id:'13',
      name_ru:`Марков В.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Markov.jpg',
      description: `Родился 20 сентября 1966 года в Смоленске. В 1980 году, по окончании 7-го класса принимал участие в археологических раскопках производившихся Смоленской археологической экспедицией МГУ, руководителем которой был профессор Д.А. Авдусин. В этом году под руководством Т.А. Пушкиной участвовал в раскопках на Центральном городище Гнездова. В 1981 – 83 годах продолжал участвовать в раскопках Центрального поселения и курганов в Гнездове под руководством ведущих археологов из МГУ. В Смоленске под руководством Н.И. Асташовой участвовал в раскопках на набережной Днепра возле ул. Большой Краснофлотской, под руководством археолога Н.В. Сапожникова участвовал в раскопках в храмовом комплексе Иоанна Богослова. В 1983 – 1984 годах под руководством Н.В. Сапожникова участвовал в археологических раскопках на Соборном Дворе в Смоленске. В 1984 – 86 годах служил в рядах Советской Армии на Дальнем Востоке. По окончании службы работал и учился в Санкт-Петербурге (тогда Ленинграде). В 1990-е годы, после возвращения в Смоленск, работал журналистом в разных смоленских СМИ, занимался также и распространением периодической печатной продукции. В 2004 году закончил исторический факультет СГПУ (Смол ГУ), учился заочно. В.В. Марков автор ряда статей по истории и культуре Смоленского края в российских и зарубежных научных изданиях. Он также автор исторической части двухтомника «Летопись Смоленщины» (2010 год) и монографии «Спасти и сохранить» (2012 год). В 2015 году вышла его монография «Золотой век Смоленска. Архитектурные памятники XII – XIII веков», в которой автор в доступной форме на основе новых фактов реконструирует эволюцию смоленского зодчества и уточняет как время строительства, так и возможных заказчиков всех исследованных к настоящему времени древних смоленских архитектурных сооружений. Является научным сотрудником смоленского историко-литературного журнала «СтранникЪ». Имеет следующие награды: медаль Блаженнейшего Митрополита Киевского и всея Украины Владимира (2013 год), «знак Святой мученицы Татьяны» за активную социальную и просветительскую деятельность (2014 год).  В 2018 году СГИИ (Смоленским государственным институтом искусств) награжден дипломом «за большой вклад в развитие культуры, активную работу по сохранению исторического наследия г. Смоленска и многолетнюю плодотворную исследовательскую работу».`,
      email: `vladrmarkoff@yandex.ru`,
      country: `ru`
   },
   {
      id:'14',
      name_ru:`Боркевич Г.С.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'15',
      name_ru:`Ярошевский Н.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Yaroshevski.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'16',
      name_ru:`Лебедев В.П.`,
      name_en:`Valentin P. Lebedev`,
       roles:[
         0
      ],
      image:'/assets/images/Lebedev.jpg',
      description: `Кандидат физико-математических наук. Основная область исследований — мусульманская средневековая нумизматика на территории России. Автор более 60 научных статей по нумизматике Средней Азии, Закавказья, Поволжья, Крыма, Южной Руси VIII-XVIII вв.`,
      email: `vpleb@mail.ru`,
      country: `ru`
   },
   {
      id:'17',
      name_ru:`Шинаков Е.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'18',
      name_ru:`Павлюков В.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Pavliukov.jpg',
      description: ``,
      email: `samloon@mail.ru`,
      country: `ru`
   },
   {
      id:'19',
      name_ru:`Волков И.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'20',
      name_ru:`Зайончковский Ю.В.`,
      name_en:``, roles:[
         0, 1
      ],
      image:'/assets/images/Zayonchkovski.jpg',
      description: ``,
      email: `zyvkharkov@gmail.com`,
      country: `ua`
   },
   {
      id:'21',
      name_ru:`Булава Л.Н.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Bulava.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'22',
      name_ru:`Шевчук А.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Shevchuk.jpg',
      description: ``,
      email: `kuchugury770@gmail.com`,
      country: `ua`
   },
   {
      id:'23',
      name_ru:`Михайленко О.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'24',
      name_ru:`Петрунин К.М.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'25',
      name_ru:`Бойко-Гагарин А.С.`,
      name_en:`Boiko-Gagarin A.`, roles:[
         0, 2
      ],
      image:'/assets/images/Gagarin.jpg',
      description: `Доктор исторических наук, ведущий научный сотрудник сектора нумизматики, фалеристики, медальерики и сфрагистики Национального музея истории Украины, г. Киев`,
      email: ``,
      country: `ua`
   },
   {
      id:'26',
      name_ru:`Зайбт В.`,
      name_en:`Werner Seibt`,
      roles:[
         0
      ],
      image:'/assets/images/Seibt.jpg',
      description: `Профессор средневековой истории Византии, Армении и Грузии в Венском университете, с 2007 года член-корреспондент Австрийской академии наук в Вене.`,
      email: ``,
      country: `at`
   },
   {
      id:'27',
      name_ru:`Ван Лаэре Р.`,
      name_en:`Raf van Laere`,
      roles:[
         0
      ],
      image:'/assets/images/VanLaere.jpg',
      description: `Raf Van Laere (1952) studied History and Assyriology at the universities of Ghent (B) and Paris – Sorbonne (F). He worked in several departments of the Belgian province Limburg concerned with the cultural heritage. He is former president of the Société royale de Numismatique de Belgique and one of the directors of its renowned Revue belge de Numismatique et de Sigillographie (RBN). A list of his numismatic and sigillographic publications can be found on the website of the Société royale http://www.numisbel.be/Vanlaere.htm. He is also former president of the Académie royale d’Archéologie de Belgique and member of the editorial board of the Revue belge d’Archéologie et d’Histoire de l’Art (RAHA) published by the Academy.`,
      email: ``,
      country: `be`
   },
   {
      id:'28',
      name_ru:`Шулепко М.И.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'29',
      name_ru:`Горбань П.И.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Gorban.jpg',
      description: `Member of Belarusian Numismatic Society`,
      email: `wildwind@tut.by`,
      country: `by`
   },
   {
      id:'30',
      name_ru:`Морозов А.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `kolmys@yandex.ru`,
      country: `ru`
   },
   {
      id:'31',
      name_ru:`Сарайкин А.С.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Saraykin.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'32',
      name_ru:`Шатохин Г.Г.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Shatokhin.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'33',
      name_ru:`Карач А.В.`,
      name_en:`Andrej Karač`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `andrew_karach@tut.by`,
      country: `by`
   },
   {
      id:'34',
      name_ru:`Ларионов Ю.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'35',
      name_ru:`Романов С.Ю.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Romanov.jpg',
      description: ``,
      email: `hordman@gmail.com`,
      country: `ru`
   },
   {
      id:'36',
      name_ru:`Шталенков И.Н.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `ishtal@tut.by`,
      country: `by`
   },
   {
      id:'37',
      name_ru:`Амосов М.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'38',
      name_ru:`Губа К.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'39',
      name_ru:`Тишкин В.Е.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'40',
      name_ru:`Орлов К.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'41',
      name_ru:`Бугарчёв А.И.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Bugarchev.jpg',
      description: `Лаборант отдела средневековой археологии Института археологии им. А.Х. Халикова АН РТ (Казань, Россия)`,
      email: `abugar.61@rambler.ru`,
      country: `ru`
   },
   {
      id:'42',
      name_ru:`Дергачёва Л.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'43',
      name_ru:`Савченко А.С.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'44',
      name_ru:`Громыко А.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `hramyka@mail.ru`,
      country: `by`
   },
   {
      id:'45',
      name_ru:`Лейбов В.Л.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'46',
      name_ru:`Родионов А.С.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'47',
      name_ru:`Купцов А.Е.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `kuptsov-an@mail.ru`,
      country: `ru`
   },
   {
      id:'48',
      name_ru:`Шапошник В.Г.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `mihas24@rambler.ru`,
      country: `ru`
   },
   {
      id:'49',
      name_ru:`Леонов Б.И.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'50',
      name_ru:`Филь А.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Phil.jpg',
      description: `Председатель правления Клуба коллекционеров Южного Урала (Тюмень).`,
      email: `filav52@mail.ru`,
      country: `ru`
   },
   {
      id:'51',
      name_ru:`Гаев А.Г.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Gaev.jpg',
      description: `Родился 1.12.1962 в Москве в семье служащих. От родителей унаследовал любовь к литературе, к книге. Подростком коллекционировал монеты Российской империи. Позднее - Средневековые восточные монеты, за которыми последовала Средневековая Европа и Русь. Публикации автора по нумизматике и истории, в частности, Золотой Орды начали появляться в различных сборниках в 1990-х. Наиболее заметной из них стала работа «Генеалогия и хронология Джучидов. К выяснению родословия нумизматически зафиксированных правителей Улуса Джучи» (Нижний Новгород, 2002), с тех пор неизменно цитируемая в научных трудах, затрагивающих вопросы истории и хронологии Орды. В  середине 2000-х, в связи с выходом третьего тома «Актовых печатей Древней Руси» В.Л. Янина и П.Г. Гайдукова заинтересовался древнерусской сфрагистикой, однако через несколько лет оставил эту тему, в связи с трудностью публикации своих исследований и общим иссяканием свежих публикаций на эту тему, которые могли бы сформировать дискуссионную среду по русской сфрагистике. Объектом интереса в последующий период являлась японская и китайская живопись и графика 17-19 вв. Вновь занялся печатями в 2017 г., когда исследования И.А. Жукова внесли свежую струю и оживили научную мысль в сфере сфрагистики Древней Руси.`,
      email: `gaev.anton@yandex.ru`,
      country: `ru`
   },
   {
      id:'52',
      name_ru:`Рублев А.И.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'53',
      name_ru:`Ушанков Е.М.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'54',
      name_ru:`Моряков А.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'55',
      name_ru:`Прошкин О.Л.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'56',
      name_ru:`Каваляускас В.`,
      name_en:` Valdas Kavaliauskas`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `lt`
   },
   {
      id:'57',
      name_ru:`Бадретдинов Н.Н.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'58',
      name_ru:`Степанов О.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'59',
      name_ru:`Кудрин А.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'60',
      name_ru:`Богуш А.К.`,
      name_en:`Anatol Bohuš`,
      roles:[
         0
      ],
      image:'/assets/images/Bogush.jpg',
      description: ``,
      email: `akb195024@gmail.com`,
      country: `by`
   },
   {
      id:'61',
      name_ru:`Орлов А.С.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'62',
      name_ru:`Климов А.М.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'63',
      name_ru:`Шептуха В.П.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'64',
      name_ru:`Савоста Р.Ю.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `savosta@gmail.com`,
      country: `ua`
   },
   {
      id:'65',
      name_ru:`Ермалицкая К.Ф.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `by`
   },
   {
      id:'66',
      name_ru:`Иванаускас Э.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `lt`
   },
   {
      id:'67',
      name_ru:`Тиунчик А.А.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Tiunchik.jpg',
      description: ``,
      email: `volna17@yandex.ru`,
      country: `by`
   },
   {
      id:'68',
      name_ru:`Дорошкевич Н.А.`,
      name_en:``, roles:[
         0, 1
      ],
      image:'/assets/images/Doroszkiewicz.jpg',
      description: ``,
      email: ``,
      country: `by`
   },
   {
      id:'69',
      name_ru:`Соболев В.В.`,
      name_en:``, roles:[
         0
      ],
      image:'/assets/images/Sobolev.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'70',
      name_ru:`Берглунд А.`,
      name_en:`Anders Berglund`,
      roles:[
         0
      ],
      image:'/assets/images/Berglund.jpg',
      description: `Anders Berglund (1951-) published his first numismatic article in the Swedish newspaper Svenska Dagbladet on the newly issued Gibraltar Crown of 1967. Later on, he published a number of articles in Skandinavisk Numismatik 1972-1976. He joined the Russian Numismatic Society in 1981 and published 19 articles in its Journal. The society also published his book “The Novgorod mint during the Swedish occupation, 1611-1617” for which he read and tabulated the records of the mint, ca 800 pages, kept in the State Archive in Stockholm. At university he studied physics and computer science. During a large part of his career (at CERN, ISO Central Secretariat, Electronic Book Technologies, IBM) he was involved in computer assisted publishing and was part of the development of international standards in the area: SGML, DSSSL, XSL, XSLT, XPath, XSL-FO. During his time at CERN he created an SGML based publishing system that was used as a model for the creation of HTML. Anders Berglund is now retired and has started to work on a number of uncompleted coin study projects.`,
      email: ``,
      country: `sw`
   },
   {
      id:'71',
      name_ru:`Нисифоров А.Н.`,
      name_en:``,
      roles:[
         0
      ],
      image:'/assets/images/Nisiforov.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'72',
      name_ru:`Майгис Ж.`,
      name_en:`Žilvinas Maigys`,
      roles:[
         0
      ],
      image:'/assets/images/Maigys.jpg',
      description: ``,
      email: ``,
      country: `lt`
   },
   {
      id:'73',
      name_ru:`Пашкевич Б.`,
      name_en:`Borys Paszkiewicz`,
      roles:[
         0, 2
      ],
      image:'/assets/images/Paszkiewicz.jpg',
      description: `University of Wrocław, professor of the Department of Medieval Archaeology. Specialist in Medieval and Modern Numismatics`,
      email: `borys.paszkiewicz@gmail.com`,
      country: `pl`
   },
   {
      id:'74',
      name_ru:`Милейски П.`,
      name_en:`Paweł Milejski`,
      roles:[
         0
      ],
      image:'/assets/images/Milejski.jpg',
      description: `Institute of Archaeology, University of Wrocław. Numismatic Department, National Ossoliński Institute, Wrocław`,
      email: `pawel.milejski90@gmail.com`,
      country: `pl`
   },
   {
      id:'75',
      name_ru:`Крицук Р.И.`,
      name_en:`Raman Krytsuk`,
      roles:[
         0, 2
      ],
      image:'/assets/images/Krytsuk.jpg',
      description: `Научный сотрудник Кабинета Монет и Медалей (Национальный музей в Варшаве, Польша). Основные научные интересы  - клады XVI-XVII вв., мелкие номиналы Восточной Европы и фальшивомонетничество.`,
      email: `kola.sonca@gmail.com`,
      country: `by`
   },
   {
      id:'76',
      name_ru:`Кабак А.В.`,
      name_en:`Andrey Kabak`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'77',
      name_ru:`Дрокин Ю.И.`,
      name_en:`Yury Drokin`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'78',
      name_ru:`Жебраускас А.`,
      name_en:`Arūnas Žebrauskas`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `lt`
   },
   {
      id:'79',
      name_ru:`Яковлев А.В.`,
      name_en:`Andrey Yakovlev`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'80',
      name_ru:`Ретман В.В.`,
      name_en:`Vladimir Retman`,
      roles:[
         0
      ],
      image:'/assets/images/Retman.jpg',
      description: `Исследователь прикладных печатей белорусской шляхты ХV-ХIХ вв.`,
      email: ``,
      country: `by`
   },
   {
      id:'81',
      name_ru:`Агафонов С.С.`,
      name_en:`S. Agafonov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'82',
      name_ru:`Багдонас Г.`,
      name_en:`Giedrius Bagdonas`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `gdrs.bagdonas@gmail.com`,
      country: `lt`
   },
   {
      id:'83',
      name_ru:`Гарбузов В.Д.`,
      name_en:`V. Garbuzov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'84',
      name_ru:`Бирюкова Е.В.`,
      name_en:`E. Biriukova`,
      roles:[
         2
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: `Кандидат исторических наук, научный сотрудник Государственного исторического музея (Москва)`,
      email: ``,
      country: `ru`
   },
   {
      id:'85',
      name_ru:`Богданов А.А.`,
      name_en:`A. Bogdanov`,
      roles:[
         2
      ],
      image:'/assets/images/Bogdanov.jpeg',
      description: `Кандидат исторических наук, руководитель сектора выставочно-экскурсионной деятельности Выставочного комплекса АО “Гознак”`,
      email: ``,
      country: `ru`
   },
   {
      id:'86',
      name_ru:`Калашникова А.В.`,
      name_en:`A. Kalashnikova`,
      roles:[
         2
      ],
      image:'/assets/images/Kalashnikova.png',
      description: `Кандидат исторических наук, заведующая отделом нумизматики Государственного исторического музея (Москва)`,
      email: ``,
      country: `ru`
   },
   {
      id:'87',
      name_ru:`Овсянников О.В.`,
      name_en:`O. Ovsianikov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'88',
      name_ru:`Спирин И.В.`,
      name_en:`I. Spirin`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `by`
   },
   {
      id:'89',
      name_ru:`Исаев В.Ю.`,
      name_en:`V. Isaev`,
      roles:[
         0
      ],
      image:'/assets/images/Isaev.jpg',
      description: `Независимый исследователь, занимается изучением монетной чеканки Золотой Орды. В 2010-е годы, совместно с П.Н. Петровым, А.И. Бугарчёвым и Е.Г. Дружининым, опубликовал ряд статей о новых находках джучидских монет Булгара и Крыма. Разработал универсальный метод изучения весовых систем - Метод грана - и применил его для реконструкции денежных систем Хорезма и Таны начала XIV века. На основе этого метода им составлен справочник «Весовые меры Античности и Средневековья».`,
      email: `isaev-vladimir@inbox.ru`,
      country: `ru`
   },
   {
      id:'90',
      name_ru:`Дзюба Ю.В.`,
      name_en:`Y. Dziuba`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `dzuba.yuriy@corum.com`,
      country: `ua`
   },
   {
      id:'91',
      name_ru:`Емельянов В.П.`,
      name_en:`V. Emelyanov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'92',
      name_ru:`Таценко С.Н.`,
      name_en:`S. Tatsenko`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'93',
      name_ru:`Кудрашов Р.А.`,
      name_en:`R. Kudrashov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'94',
      name_ru:`Набелкин О.А.`,
      name_en:`O. Nabelkin`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'95',
      name_ru:`Петухов С.П.`,
      name_en:`S. Petukhov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'96',
      name_ru:`Староверов Д.А.`,
      name_en:`D. Staroverov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: `dmitry.a.staroverov@gmail.com`,
      country: `by`
   },
   {
      id:'97',
      name_ru:`Безпалько В.В.`,
      name_en:`V. Bezpalko`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ua`
   },
   {
      id:'98',
      name_ru:`Пашинский В.М.`,
      name_en:`V. Pashinskiy`,
      roles:[
         0
      ],
      image:'/assets/images/Pashinskii.jpg',
      description: `Социолог. Интерес к средневековой нумизматике продиктован двумя гипотезами: кладообразование как потенциальный индикатор военной активности; военная активность как потенциальный индикатор циклических социокультурных процессов.`,
      email: `v_m_p@bk.ru`,
      country: `ru`
   },
   {
      id:'99',
      name_ru:`Войтехович А.В.`,
      name_en:`A. Vaytsekhovich`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: `Белорусский археолог. Кандидат исторических наук (2011). Заведующий сектором археологических научных фондов Института истории НАН Беларуси.`,
      email: `voitehowich@tut.by`,
      country: `by`
   },
   {
      id:'100',
      name_ru:`Яцкевич Д.Л.`,
      name_en:`Dzmitry Yatskevich`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: `Яцкевич Дмитрий Леонтьевич окончил истфак БГУ, аспирантуру БелНИИ документоведения и архивного дела. Работал в Белорусском реставрационно-проектном институте, Национальном историческом архиве Беларуси, Государственном музее истории белорусской литературы, Национальном историко-культурном музее-заповеднике «Несвиж». Исследует историю и культуру Беларуси городов Беларуси XVI-XVIII вв., праблемы магдебургского права, нобилитации мещан, специальные исторические науки и др. Автор и соавтор ряда книг исторической тематики. Являлся составителем и ответственным секретарем ежегодника «Архивариус», составителем ежегодника «Acta anniversaria». Автор более 300 научных публикаций.`,
      email: ``,
      country: `by`
   },
   {
      id:'101',
      name_ru:`Волков Е.Г.`,
      name_en:`Eugenij Volkov`,
      roles:[
         0
      ],
      image:'/assets/images/Volkov.jpg',
      description: `В 2006 году окончил Брестский технический университет. В этом же году начал увлекаться нумизматикой вслед за отцом. Вел свой блог, вступил в БелРООК. В 2021 году издал первый том книги, посвященный монетам с гербом ВКЛ, в 2025 вышел второй том. Активно работает над исследованием темы Брестского монетного двора.`,
      email: `volkov.eugenij@gmail.com`,
      country: `by`
   },
   {
      id:'102',
      name_ru:`Никитчик А.Д.`,
      name_en:`A. Nikitchik`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: `Брестский краевед. Родился 15.07.1958. С 1979 г. по 2020 г. работал в редакционно-издательском отделе Брестского государственного технического университета, где, в том числе, публиковались материалы по истории г. Бреста и области. БПИ окончил в 1984 г. по специальности ПГС. Самостоятельные исследования начал в 2000 г. В область интереса включены темы:  Первое упоминание г. Берестья; История сакральных памятников города; Брестский замок; Гравюра № 52 Дальберга из «De Rebus …»; шведско-трансильванско-казацкая инвазия в мае 1657 г. (Потоп), о чём рассказано в 15 научных публикациях.`,
      email: ``,
      country: `by`
   },
   {
      id:'103',
      name_ru:`Рева Р.Ю.`,
      name_en:`R.Y. Reva`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'104',
      name_ru:`Сычев Ю.В.`,
      name_en:`Y. Sychev`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'105',
      name_ru:`Федорова Е.А.`,
      name_en:`E.A. Fedorova`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'106',
      name_ru:`Болдин И.В.`,
      name_en:`I.V. Boldin`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'107',
      name_ru:`Поваренков А.В.`,
      name_en:`A.V. Povarenkov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'108',
      name_ru:`Штрафметов А.Б.`,
      name_en:`A.B. Shtrafmetov`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   },
   {
      id:'109',
      name_ru:`Пятинкин К.П.`,
      name_en:`K.P. Pyatsinkin`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `by`
   },
   {
      id:'110',
      name_ru:`Стародубцев Г.Ю.`,
      name_en:`G.Yu. Starodubtsev`,
      roles:[
         0
      ],
      image:'/assets/images/Unnamed_scientist.jpg',
      description: ``,
      email: ``,
      country: `ru`
   }
];
